import { render } from "./ButtonWhatsappComponent.vue?vue&type=template&id=2f5f7fd1&scoped=true"
import script from "./ButtonWhatsappComponent.vue?vue&type=script&lang=js"
export * from "./ButtonWhatsappComponent.vue?vue&type=script&lang=js"

import "./ButtonWhatsappComponent.vue?vue&type=style&index=0&id=2f5f7fd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5f7fd1"]])

export default __exports__